import Request from '../v1/request'

const Notification = {
  getNotificationChannelsList (callback) {
    Request.get('notification/channels').then(callback).catch(this.bad_answer)
  },
  saveNotificationChannel (params, callback) {
    Request.post('notification/save-channel', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  deleteNotificationChannel (params, callback) {
    Request.post('notification/delete-channel', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getTriggersList(params, callback) {
    Request.post('notification/triggers', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  saveNotification(params, callback) {
    Request.post('notification/save', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getListNotification(callback) {
    Request.post('notification/list').then(callback).catch(this.bad_answer)
  },
  deletetNotification(params, callback) {
    Request.post('notification/delete', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getNotificationInterfaces(params, callback) {
    Request.post('notification/interfaces', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Notification
